import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import HomePage from '@/features/home/pages/HomePage';
import ProductsPage from '@/features/products/pages/ProductsPage';
import CartPage from '@/features/cart/pages/CartPage';
import LoginPage from '@/features/auth/pages/LoginPage';
import AdminLayout from '@/features/admin/layout/AdminLayout';
import DashboardPage from '@/features/admin/pages/DashboardPage';
import AdminProductsPage from '@/features/admin/pages/AdminProductsPage';
import AdminSalesPage from '@/features/admin/pages/AdminSalesPage';
import RequirePermission from '@/features/auth/components/RequirePermission';
import AdminUsersPage from '@/features/users/pages/AdminUsersPage';
import AdminSettingsPage from '@/features/settings/pages/AdminSettingsPage';
import RequireAuthentication from '@/features/auth/components/RequireAuthentication';
import AdminFeedbacksPage from '@/features/feedbacks/pages/AdminFeedbacksPage';
import AdminArticlesPage from '@/features/articles/pages/AdminArticlesPage';
import AccountPage from '@/features/account/pages/AccountPage';
import SaleHistoryPage from '@/features/sales/pages/SaleHistoryPage';

export const routes = createBrowserRouter([
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'products', element: <AdminProductsPage /> },
      {
        element: <RequireAuthentication />,
        children: [
          { path: 'feedbacks', element: <AdminFeedbacksPage /> },
          { path: 'articles', element: <AdminArticlesPage /> },
          {
            element: <RequirePermission permission={['SALE_READ_ALL', 'SALE_READ_OWN']} />,
            children: [
              { path: 'sales/history', element: <SaleHistoryPage /> },
            ],
          },
          {
            element: <RequirePermission permission="USER_READ_ALL" />,
            children: [
              { path: 'users', element: <AdminUsersPage /> },
            ],
          },
        ],
      },
      { path: 'sales', element: <AdminSalesPage /> },
      { path: 'settings', element: <AdminSettingsPage /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'products', element: <ProductsPage /> },
      { path: 'cart', element: <CartPage /> },
      { path: 'login', element: <LoginPage /> },
      {
        element: <RequireAuthentication />,
        children: [
          { path: 'account', element: <AccountPage /> },
        ],
      },
    ]
  }
]);
